import { createElement } from "react";
import { join } from "../fable_modules/fable-library.3.7.9/String.js";
import { cons, ofArray, singleton } from "../fable_modules/fable-library.3.7.9/List.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.64.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library.3.7.9/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.2.18.0/ElementBuilders.fs.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library.3.7.9/Seq.js";

export function iconButton(iconClass, isDisabled, onClick) {
    let elems_1, elms;
    const props_2 = ofArray([["className", "is-small"], ["disabled", isDisabled], ["onClick", onClick], (elems_1 = [(elms = singleton(createElement("i", {
        className: join(" ", ["fa", iconClass]),
    })), createElement("span", {
        className: "icon",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]);
    return createElement("button", createObj(Helpers_combineClasses("button", props_2)));
}

export function spinnerOverlay(spin, maybeStyles, children) {
    let elems;
    const spinnerChildren = spin ? cons(createElement("div", createObj(ofArray([["style", {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "white",
        opacity: 0.7,
        zIndex: 1000,
    }], (elems = [createElement("div", createObj(toList(delay(() => append(singleton_1(["className", "spinner"]), delay(() => {
        let styles;
        return append((maybeStyles == null) ? ((empty())) : ((styles = maybeStyles, singleton_1(["style", createObj(styles)]))), delay(() => singleton_1(["children", "Loading..."])));
    }))))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), children) : children;
    return createElement("div", {
        style: {
            position: "relative",
            minHeight: 400,
        },
        children: Interop_reactApi.Children.toArray(Array.from(spinnerChildren)),
    });
}

